export default __webpack_public_path__ + "static/wiigamers2_b-fdc3f577854d2a2fa10a46f84be16c77.png";